import { PageSize } from '@/constant';
import { TGetListContractedForeignBusinessParams } from '@/services';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IContractedForeignBusinessDetailStore,
	IPayloadGetContractedForeignBusinessListRequest,
	IPayloadGetContractedForeignBusinessListSuccess,
	TPayloadAddForeignBusinessInfoRequest,
	TPayloadDeleteForeignBusinessInfoRequest,
} from './contracted-foreign-business.type';

const initParams: TGetListContractedForeignBusinessParams = {
	page: 1,
	pageSize: PageSize.S,
	allData: false,
	id: 0,
};

const initialState = {
	contractedForeignBusiness: {
		fetching: false,
		data: [] as IContractedForeignBusinessDetailStore[],
		total: 0,
		params: initParams,
	},
};

const ContractedForeignBusiness = createSlice({
	initialState,
	name: 'contractedForeignBusiness',
	reducers: {
		/**---- GET CONTRACTED FOREIGN BUSINESS LIST START ---- */
		getContractedForeignBusinessListRequest: (
			state,
			action: PayloadAction<IPayloadGetContractedForeignBusinessListRequest>
		) => {
			state.contractedForeignBusiness.fetching = true;
			state.contractedForeignBusiness.params = action.payload;
		},
		getContractedForeignBusinessListSuccess: (
			state,
			action: PayloadAction<IPayloadGetContractedForeignBusinessListSuccess>
		) => {
			const { content, total } = action.payload;
			state.contractedForeignBusiness.data = content;
			state.contractedForeignBusiness.fetching = false;
			state.contractedForeignBusiness.total = total;
		},
		getContractedForeignBusinessListFailure: (state) => {
			state.contractedForeignBusiness.fetching = false;
		},
		/**---- GET CONTRACTED FOREIGN BUSINESS LIST END ---- */

		/**---- DELETE CONTRACTED FOREIGN BUSINESS START ---- */
		deleteContractedForeignBusinessRequest: (
			state,
			action: PayloadAction<TPayloadDeleteForeignBusinessInfoRequest>
		) => {
			state.contractedForeignBusiness.fetching = true;
		},

		deleteContractedForeignBusinessSuccess: (state) => {
			state.contractedForeignBusiness.fetching = false;
		},

		deleteContractedForeignBusinessFailure: (state) => {
			state.contractedForeignBusiness.fetching = false;
		},
		/**---- DELETE CONTRACTED FOREIGN BUSINESS END ---- */

		/**---- ADD CONTRACTED FOREIGN BUSINESS START ---- */
		addContractedForeignBusinessRequest: (
			state,
			action: PayloadAction<TPayloadAddForeignBusinessInfoRequest>
		) => {
			state.contractedForeignBusiness.fetching = true;
		},

		addContractedForeignBusinessSuccess: (state) => {
			state.contractedForeignBusiness.fetching = false;
		},

		addContractedForeignBusinessFailure: (state) => {
			state.contractedForeignBusiness.fetching = false;
		},
		/**---- ADD CONTRACTED FOREIGN BUSINESS END ---- */
	},
});

export const ContractedForeignBusinessSelectors = {
	selectContractedForeignBusinessList: (state: RootState) =>
		state.contractedForeignBusiness.contractedForeignBusiness.data,
	selectContractedForeignBusinessListParams: (state: RootState) =>
		state.contractedForeignBusiness.contractedForeignBusiness.params,
	selectContractedForeignBusinessListFetching: (state: RootState) =>
		state.contractedForeignBusiness.contractedForeignBusiness.fetching,
	selectContractedForeignBusinessListTotal: (state: RootState) =>
		state.contractedForeignBusiness.contractedForeignBusiness.total,
};

export const ContractedForeignBusinessActions =
	ContractedForeignBusiness.actions;
export const ContractedForeignBusinessReducer =
	ContractedForeignBusiness.reducer;
